import { render, staticRenderFns } from "./ComplaintListCopy.vue?vue&type=template&id=299c9ccc&"
import script from "./ComplaintListCopy.vue?vue&type=script&lang=js&"
export * from "./ComplaintListCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports